<template>
  <div class="container py-5">
    <p>
    <b>遠京企業股份有限公司</b>為日本TSK正式授權負責臺灣代理銷售業務
    <br><br>
    TSK日本醫療專用尖針、鈍針即將隆重登場🎉
    <br>
    遠京期待以優質的醫療設備，與您攜手共進！
    <br><br>
    也敬請密切關注我們的粉絲專頁，隨時掌握最新消息！
    <br>
    ⮕<a href="https://www.facebook.com/TSKlabTaiwan" target="_blank" rel="noopener">https://www.facebook.com/TSKlabTaiwan</a>
    </p>

    <img
      class="img-md rounded"
      src="@/assets/images/zh-TW/news/new_42.jpg"
    />


  </div>
</template>
<script>
export default {};
</script>
